import { render, staticRenderFns } from "./ViewDetail.vue?vue&type=template&id=0b3f7128&scoped=true"
import script from "./ViewDetail.vue?vue&type=script&lang=js"
export * from "./ViewDetail.vue?vue&type=script&lang=js"
import style1 from "./ViewDetail.vue?vue&type=style&index=1&id=0b3f7128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f7128",
  null
  
)

export default component.exports